import { languages, setLanguage, getLanguage } from "../i18n";

class {
  onCreate() {
    // Load theme from localStorage or default to dark
    const savedTheme = localStorage ? localStorage.getItem("theme") || "dark" : "dark";
    this.state = {
      language: getLanguage(),
      theme: savedTheme,
      languages,
    };
    this.applyTheme(savedTheme);
  }

  onMount() {
    this.applyTheme(this.state.theme);
  }

  applyTheme(theme) {
    if (!document || !localStorage) return;
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }

  toggleTheme() {
    const newTheme = this.state.theme === "dark" ? "light" : "dark";
    this.state.theme = newTheme;
    this.applyTheme(newTheme);
  }

  handleLanguageChange(event) {
    const lang = event.target.value;
    this.state.language = lang;
    setLanguage(lang);
    window.dispatchEvent(new CustomEvent("language-changed", { detail: { language: lang } }));
  }
}

<div
  id="page-controls"
  class=[
    "absolute right-3 top-16 p-2 pt-1 w-fit",
    "flex flex-col items-center justify-around gap-3",
    "bg-gray-800 border-gray-700 border rounded-lg shadow-lg",
    "transition-all duration-300 ease-in-out"
  ]
>
  <!-- Language Dropdown -->
  <div class="flex flex-col gap-2">
    <label for="language" class="text-sm text-gray-400">Change Language</label>
    <select
      id="language"
      value=state.language
      on-change("handleLanguageChange")
      class="bg-gray-800 border border-gray-600 text-white text-sm rounded-md px-3 py-2 focus:ring-2 focus:ring-green-500"
    >
      <for|lang| of=state.languages>
        <option value=lang.code selected=(lang.code === state.language)>${lang.flag} ${lang.label}</option>
      </for>
    </select>
  </div>

  <!-- Theme Switch -->
  <div class="flex flex-col gap-2">
    <label for="theme-toggle" class="text-sm text-gray-400">Switch Theme</label>
    <div class="flex items-center gap-2">
      <span class="text-sm text-gray-400"><Icon icon="dark" /></span>
      <button
        role="switch"
        aria-checked=(state.theme === "light")
        on-click("toggleTheme")
        class=[
          "relative inline-flex h-6 w-11 items-center rounded-full transition-colors",
          { "bg-green-500": state.theme === "light", "bg-gray-600": state.theme === "dark" }
        ]
      >
        <span
          class=[
            "inline-block h-4 w-4 transform rounded-full bg-white transition-transform",
            { "translate-x-6": state.theme === "light", "translate-x-1": state.theme === "dark" }
          ]
        ></span>
      </button>
      <span class="text-sm text-gray-400"><Icon icon="light" /></span>
    </div>
  </div>
</div>
